<template>
    <div v-if="available">
        <!-- cart_block -->
        <div class="row cart_block mt_sm">
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите <b>способ доставки заказа</b>. Отправка товаров
                    осуществляется в течение 2-х рабочих дней с момента
                    поступления денежных средств на наш банковский счет, с
                    понедельника по пятницу с 9 до 19 часов.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.delivery }"
                            v-model="delivery.name"
                            readonly
                        />
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalDelivery"
                        >
                            Выбрать способ доставки
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->

        <!-- title -->
        <div class="row ki_block_title block_total mt_xs">
            <div class="col-12">
                <span class="other_lg">Доставка {{ deliveryPrice }} р.</span>
                <span class="price_lg">Итого {{ total }} р.</span>
            </div>
        </div>
        <!-- // title -->

        <!-- cart_block -->
        <div
            v-if="pickup_points && pickup_points.length"
            class="row cart_block mt_sm"
        >
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите <b>пункт выдачи заказов</b>.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.pickup_point }"
                            v-model="pickup_point_name"
                            readonly
                        />
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalPickupPoint"
                        >
                            Выбрать пункт выдачи заказов
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->

        <!-- cart_block -->
        <div
            v-else-if="delivery.id != 1 && delivery.id != null"
            class="row cart_block mt_sm"
        >
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите <b>адрес доставки</b>.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.address }"
                            v-model="address.address"
                            readonly
                        />
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalAddress"
                        >
                            Выбрать адрес
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->

        <order-form-delivery-method-modal></order-form-delivery-method-modal>
        <order-form-delivery-pickup-point-modal></order-form-delivery-pickup-point-modal>
        <order-form-delivery-address-modal></order-form-delivery-address-modal>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    methods: {},
    computed: {
        // Выбранный способ доставки
        delivery() {
            return this.$store.state.order.delivery;
        },
        pickup_points() {
            if (this.$store.state.order.delivery.id) {
                let delivery = this.$store.state.delivery.deliveries.find(
                    (value, index) => {
                        return value.id == this.$store.state.order.delivery.id;
                    }
                );

                if (typeof delivery.points !== "undefined") {
                    return delivery.points;
                }
            }

            return false;
        },
        pickup_point_name() {
            if (!this.$store.state.order.pickup_point.name) {
                return '';
            }

            return this.$store.state.order.pickup_point.name + ' (' + this.$store.state.order.pickup_point.address + ')';
        },
        address() {
            return this.$store.state.order.address;
        },
        errors() {
            return this.$store.state.order.errors;
        },
        amount() {
            return this.$store.getters["order/amount"];
        },
        deliveryPrice() {
            return this.$store.getters["order/deliveryPrice"];
        },
        total() {
            return this.$store.getters["order/total"];
        },
        available() {
            return !!this.$store.state.order.payer.id;
        },
    },
    mounted() {
        this.$store.dispatch("delivery/getDeliveries");
        this.$store.dispatch("delivery/getAddresses");
        // this.$store.dispatch("delivery/getPickupPoints");
    },
};
</script>
